/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { Form, FormLayout, FormValidator, isValid, PasswordInput, TextInput, defaultMaskPlaceholder } from '@veeam-vspc/components';

import type { WizardStep, WizardStepData } from '@veeam-vspc/components';

import { StepLayout } from 'components/layouts/StepLayout';
import { useLang } from 'views/providers/LangProvider/hooks';

import type { AdminUserModel } from '../../interfaces';


export const stepValidate = (data: AdminUserModel) => {
    const validator = new FormValidator(data);

    validator.validate('domain').string()
        .maxLength(253);
    validator.validate('userName').string()
        .maxLength(253);
    validator.validate('password').string()
        .maxLength(253);

    return validator.result();
};

export const Domain = ({ data, validationState, onDataChange }: WizardStepData<AdminUserModel>) => {
    const lang = useLang();

    return (
        <Form
            value={data}
            validate={stepValidate}
            validationState={validationState}
            onChange={onDataChange}
        >
            <StepLayout
                title={lang.DOMAIN}
                description={lang.SPECIFY_DOMAIN_NAME_AND_CONNECTION_ACCOUNT}
            >
                <FormLayout inlineLabel>
                    <TextInput
                        name='domain'
                        placeholder={lang.LOCALHOST}
                        label={lang.DOMAIN_NAME}
                    />

                    <TextInput
                        name='userName'
                        label={lang.USERNAME}
                    />

                    <PasswordInput
                        name='password'
                        label={lang.PASSWORD}
                        hasValueMask={defaultMaskPlaceholder}
                    />
                </FormLayout>
            </StepLayout>
        </Form>
    );
};

export const getDomainStep = (title: string): WizardStep<AdminUserModel> => ({
    title,
    isHidden: ({ isEdit }) => isEdit,
    validate: ({ data }) => isValid(stepValidate, data),
    render: data => <Domain {...data} />,
});
